<template>
  <v-card>
    <v-card-text>
      <v-container container--fluid grid-list-md>
         <v-row justify="space-between">
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
            <v-text-field
              v-if="item.type === 'text'"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-text-field>
            <v-select
              :items="item.selectItems"
              v-if="item.type === 'select'"
              v-model="clientInfo[item.key]"
              :label="item.text"></v-select>
            <v-switch
              v-if="item.type === 'switch'"
              v-model="clientInfo[item.key]"
              :label="item.text"
            ></v-switch>
          </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  // @group EditClient
  // Client Accounting Information tab for EditClient
  export default {
    name: "AccountingInformation",
    props: {
      // Client Object
      clientInfo: Object,
    },
    data() {
      return {
        items: [
          {text: 'Legal Name', key: 'legal_name', type: 'text'},
          {text: 'ABN', key: 'abn', type: 'text'},
          {text: 'Accounting Address', key: 'accounting_address', type: 'text'},
          {text: 'Suburb', key: 'accounting_suburb', type: 'text'},
          {text: 'State', key: 'accounting_state', type: 'text'},
          {text: 'Postcode', key: 'accounting_postcode', type: 'text'},
          {text: 'Telephone', key: 'accounting_phone', type: 'text'},
          {text: 'Contact Name', key: 'accounting_contact_name', type: 'text'},
          {text: 'Contact Phone', key: 'accounting_contact_phone', type: 'text'},
          {text: 'Contact Email', key: 'accounting_contact_email', type: 'text'},
          {text: 'Payment Terms', key: 'payment_terms', type: 'select', selectItems: ['7 Days','14 Days','21 Days','28 Days']},
          {text: 'Oracle Account Number', key: 'oracle_account_number', type: 'text'},
          {text: 'Oracle Site Number', key: 'oracle_site_number', type: 'text'},
          {text: 'Send CSV Invoice', key: 'send_csv_invoice', type: 'switch'},
        ]
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/AccountingInformation.vue